import { createClient } from '@supabase/supabase-js'

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// CRA の環境変数をフロントで使う際に再利用できるようエクスポートしておく
export const supabaseAnonKey = supabaseKey

const supabase = createClient(supabaseUrl, supabaseKey)
export default supabase
